import React from 'react';

interface IEvidencniUdaje {}

const EvidencniUdaje: React.FC<IEvidencniUdaje> = () => {
    return <></>;
};

export default EvidencniUdaje;
